import { render, staticRenderFns } from "./edit-business.vue?vue&type=template&id=3d11e33a&scoped=true&"
import script from "./edit-business.vue?vue&type=script&lang=js&"
export * from "./edit-business.vue?vue&type=script&lang=js&"
import style0 from "./edit-business.vue?vue&type=style&index=0&id=3d11e33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11e33a",
  null
  
)

export default component.exports